import { Budget } from '../types/budget';
import Papa from 'papaparse';
import i18n from '../i18n';
import { getDisplayLabel } from '../utils/budget';

/**
 * Export transactions to CSV format using PapaParse
 */
export const exportToCSV = (budget: Budget): string => {
  // Get the translated version of "common" in current language
  const commonTranslated = i18n.t('defaults.responsibles.common');

  const csvData = budget.transactions.map((transaction) => ({
    category: getDisplayLabel(transaction.category, budget.categories),
    responsible:
      transaction.responsible === 'common'
        ? commonTranslated
        : getDisplayLabel(transaction.responsible, budget.responsibles),
    description: transaction.description,
    destination: getDisplayLabel(transaction.destination, budget.destinations),
    amount: transaction.amount,
  }));

  return Papa.unparse(csvData);
};

/**
 * Download transactions as a CSV file
 */
export const downloadCSV = (budget: Budget, budgetName: string): void => {
  // Get the CSV content
  const csvContent = exportToCSV(budget);

  // Create a Blob with the CSV content
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Create a download link
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${budgetName}.csv`;

  // Trigger the download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
